/*
 * @Author: luoguo
 * @Date: 2024-01-30 17:45:13
 * @LastEditTime: 2025-11-06 15:44:36
 * @LastEditor: zhangkun
 * @Description:
 */
export default {
    /* 基础公共接口 */
    companyInfo: "/api/getMixParam",
    dict: "/api/getDict",
    addUserBehavior: "/api/addUserBehavior", // 记录日志
    uploadFile: "/sale-mid/file/upload",
    leaveTracesLog: "/api/leaveTracesLog", // 留痕
    banks: "/api/qryAddableBankList", // 查询可增银行
    bankBranch: "/api/qryBankBranch", // 查询银行支行
    bannerAds: "/api/qryBannerService", // banner 广告数据
    acctProfessionalInfo: "/api/acctProfessionalInfo", // 查询专业投资者信息
    qryBusinessFile: "/api/qryBusinessFile", // 查询业务文件
    qryLatestAppVersion: "api/qryLatestAppVersion", // agate查询版本信息接口
    base64: "/sale-mid-ump/file/base64", // 文件转base64
    combPersonAuth: "/api/combPersonAuth", // 自然人联网查询
    qryModuleParamService: "/api/qryModuleParamService", // 基金列表查询私募产品
    /* 基金相关 */
    fundList: "/api/qryPageProductService", // 基金列表
    queryProdTradedList: "/api/queryProdTradedList", // 已交易基金列表
    newFunds: "/api/qryFundNewService", // 新发基金
    fundNavHistory: "/api/qryProductNavHistoryService", // 基金历史净值
    fundDetail: "/api/qryFundDetailService", // 查询基金详情
    fundManagers: "/api/qryManagerService", // 查询基金经理
    fundManagerResume: "/api/qryFundManagerResume", // 查询基金经理的从业经历
    fundManagerAward: "/api/qryAwardInfo", // 查询基金经理的荣誉信息
    fundManagerCompany: "/api/qryCompanyInfo", // 查询基金经理所在基金公司的信息
    fundRoadsInfo: "/api/qryRoadShowInfo", // 查询路演信息
    qryProductExtService: "/api/qryProductExtService", // 查询基金公告列表
    qryFundNoticeDetailService: "/api/qryFundNoticeDetailService", // 查询基金公告内容
    combQueryFundlist: "/api/combQueryFundlist", // 查询产品信息 综合理财系统网上交易业务接口规范-系统类文档
    qryCompanyInfo: "/api/qryCompanyInfo", // 查询基金公司信息
    qryFundPeriodGain: "/api/qryFundPeriodGain", // 基金阶段涨幅
    qryFundIndicators: "/api/qryFundIndicators", // 基金收益/风险指标
    qryCollectFund: "/api/qryCollectFund", // 自选列表
    qryFundPeriodReturn: "/api/qryFundPeriodReturn", // 查询收益曲线
    qryFundPeriodIndexReturn: "/api/qryFundPeriodIndexReturn", // 查询指数收益曲线
    qryFundStrategyType: "/api/qryFundStrategyType", // 查询基金策略类型
    combQueryTransValidList: "/api/combQueryTransValidList", // 交易记录 分红信息查询143
    qryDividendInfo: "/api/qryDividendInfo", // 交易分红查询
    combQueryAcctElecontract: "/api/combQueryAcctElecontract", // 查询客户电子合同信息
    queryCustAcctElecontractFile: "/api/queryCustAcctElecontractFile", // 查询客户电子合同信息
    /** 系统公告 */
    qrySysNotice: "/api/qrySysNotice", // 查询系统公告列表
    qryFundFeeService: "/api/qryFundFeeService", // 查询基金费率
    qryTransFee: "/api/qryTransFee", // 查询认/申购/赎回/转换费用
    qryTransDateInfo: "/api/qryTransDateInfo", // 查询基金交易流程时间节点信息
    cfgFundrealtimeQueryAll: "/api/cfgFundrealtimeQueryAll", // 查询现金宝信息
    combTransRedeemForBuyLimit: "/api/combTransRedeemForBuyLimit", // 赎回转购限额查询
    combQueryTransRedeemForBuyList: "/api/combQueryTransRedeemForBuyList", // 赎回转申购-转入目标基金列表
    combTransRealtaRedeemForBuy: "/api/combTransRealtaRedeemForBuy", // 实时TA购买
    combTransRedeemForBuy: "/api/combTransRedeemForBuy", // 赎回转购买
    combTransRealtaRedeem: "/api/combTransRealtaRedeem", // 实时TA赎回/快赎
    combTransBuy: "/api/combTransBuy", // 普通购买使用省钱购下单
    combTrusteeAll: "/api/combTrusteeAll", // 跨系统转托管
    combTrusteeIn: "/api/combTrusteeIn", // 转托管转入
    /* 资产相关 */
    assetList: "/api/qryAssetTotal", // 客户持有资产列表
    qryAsset: "/api/qryAsset", // 客户持有资产列表分页
    qrySpecialAsset: "/api/qrySpecialAsset", // 查询专户资产
    qryBeforeRedeem: "/api/tradeRedeemInfo", // 赎回前查询
    redeem: "/api/tradeRedeem", // 赎回
    qryProductOrgService: "/api/qryProductOrgService", // 查询销售机构
    qryHistoryProfit: "/api/queryHistoricalRevenueData", // 查询收益统计
    qryBalFundProfitDetail: "/api/qryBalFundProfitDetail", // 查询历史收益明细信息
    queryWaitToDoneConTract: "/api/queryWaitToDoneConTract", // 查询待签署的补充协议
    queryWaitToDoneDoubleRecord: "/api/queryWaitToDoneDoubleRecord", // 查询待双录的订单
    qryCrmCustInfo: "/api/qryCrmCustInfo",

    /* 交易相关 */
    orderList: "/api/qryOrderListService", // 交易流水
    dxOrderList: "/api/qryCrmTransConfirm", // 代销交易记录
    orderDetail: "/api/qryOrderDetailService", // 交易详情
    cancelOrder: "/api/baseCancelOrderHandler", // 撤单
    cancelableOrderList: "/api/qryBaseOrderCancelService", // 查询可撤单记录
    tradeConvertInfo: "/api/tradeConvertInfo", // 转换前查询
    tradeConvertInfoService: "/api/tradeConvertInfoService", // 转换前查询
    tradeConvert: "/api/tradeConvert", // 转换下单
    qryTransInfo: "/api/qryTransInfo", // 购买前查询
    fundBuyOrderPay: "/api/fundBuyOrderPay", // 银行卡/汇款/现金宝购买下单
    tradePlanInfo: "/api/tradePlanInfo", // 定投前查询
    acctPlanOpen: "/api/acctPlanOpen", // 定投协议开通
    acctPlan: "/api/acctPlan", // 定转协议查询
    combCalPlanModle: "/api/combCalPlanModle", // 定投计算器
    acctPlanOperation: "/api/acctPlanOperation", // 定投协议暂停/恢复/终止
    qryPlanTotalInfo: "/api/queryAgrPlanTotalInfo", // 客户定投汇总信息查询
    qryRemittanceInfo: "/api/qryRemittanceInfo", // 查询汇款信息
    getInfoByPaychannel: "/api/getInfoByPaychannel", // 查询汇款信息
    queryAwaitSignElecontract: "/api/queryAwaitSignElecontract", // 查询签署合同
    combAppEleontractSign: "/api/combAppEleontractSign", // 终端电子合同签署
    queryValidPwdTrdMethod: "/api/queryValidPwdTrdMethod", // 查询业务是否需要验证交易密码
    qryAppTransService: "/api/qryAppTransService", // 查询定投详情历史扣款
    qeryCfgSysconfigExt: "/api/qeryCfgSysconfigExt", // 查询系统交易日
    combQueryAgrPlan: "/api/combQueryAgrPlan", // 查询定投协议
    queryCfgTaInfos: "/api/queryCfgTaInfos", // 查询TA信息
    checkComplianceService: "/api/checkComplianceService", // 购买前校验
    combTransRealtaCancel: "/api/combTransRealtaCancel", // 实时TA撤单
    /* 增值模块 */
    combQueryFundlimit: "/api/combQueryFundlimit", // 交易限额查询

    /* 登录注册 */
    acctInfo: "/api/qryAcctInfo",
    professionInfo: "/api/acctProfessionalInfo",

    registerSms: "/api/sendRegisterSms",
    loginSms: "/api/sendLoginSms",
    login: "/auth/remote/login",
    logout: "/auth/remote/logout",
    userinfo: "/api/qryAcctInfo",
    ocr: "/api/combOcrIdcard",
    fOcr: "/api/foreignIdCardOcr",
    bindAccount: "/api/loginBindHandler",
    openAcct: "/api/openAcct",
    isOpenAcct: "/api/isOpenAcct",
    checkUserExist: "/api/checkUserExist",
    openAcctCallback: "/api/openAcctCallback",
    changePhoneSms: "/api/changePhoneSms", // 更换手机号
    qryCustomerServiceUrl: "/api/qryCustomerServiceUrl", // 已登录获取在线客服地址
    identifyVerification: "/api/identifyVerification", // 身份证信息校验
    openAcctAfterToken: "/api/openAcctAfterToken", // 免注册开户获取登录令牌
    // 税收居民身份列表
    crslist: "/api/acct/crs/info",

    // 风险测评题目
    selectQuestionAndOption: "/api/selectQuestionAndOption",
    // 提交风测
    combCustRiskService: "/api/combCustRiskService",
    custKnowledgeRisk: "/api/custKnowledgeRisk",
    // CRS
    qryAcctCrsInfoService: "/api/qryAcctCrsInfoService", // 涉税信息查询
    addAcctCrsInfoHandler: "/api/addAcctCrsInfoHandler", // 增加涉税信息
    updAcctCrsInfoHandler: "/api/updAcctCrsInfoHandler", // 修改涉税信息
    delAcctCrsInfoHandler: "/api/delAcctCrsInfoHandler", // 删除涉税信息

    // 合格投资者
    midBusiness0BDForTerminal: "/api/midBusiness0BDForTerminal", // 1-私募合格投资者 2-资管合格投资者 3-私募与资管合格投资者)
    midBusiness0BE: "/api/midBusiness0BE", // 已开户合格投资者声明有效期
    noOpenDisclaimersignTempHandler: "/api/noOpenDisclaimersignTempHandler", // 未开户合格投资者声明信息暂存

    // 适当性
    suitableInfo: "/api/qrySuitableInfo", // 投资者信息补录查询
    updateSuitableInfo: "/api/suitableUpdateHandler", // 适当性信息补录
    suitableHandleList: "/api/qryWarnListService", // 待适当性处理协议
    baseWarnProcessHandler: "/api/baseWarnProcessHandler", // 适当性不匹配协议处理
    sdxCheck: "/api/acctSdxCheck", // 适当性检查
    sdxProtocol: "/api/qryProtocolContent", // 查询交易类适当性协议(暂无接口)
    modifySmAuthorization: "/api/modifySmAuthorization", // 电子签署约定书

    // 银行卡管理
    sendBindCardSms: "/api/authSend", // 发送开户短信
    checkBindCardSms: "/api/authReceive", // 校验开户短信
    sendAddCardSms: "/api/addCardSend", // 发送增卡短信
    checkAddCardSms: "/api/addCardReceive", // 校验增卡短信
    myBankCards: "/api/qryActivatedBankCards", // 已绑定银行卡
    delBankCard: "/api/delCard", // 删除已绑定银行卡
    delCardPayChannel: "/api/delCardPayChannel", // 根据渠道删除已绑定银行卡
    addBankCard: "/api/addBankCard", // 增卡
    qryBankByCertInfo: "/api/qryBankByCertInfo", // 通过证件信息查询银行卡
    combPayChannelCreate: "/api/combPayChannelCreate", // 添加汇款卡
    combBankCardCreate: "/api/combBankCardCreate", // 添加汇款卡
    queryPaychannel: "/api/queryPaychannel", // 获取银行卡网点列表
    combQryActivatedBankCard: "/api/combQryActivatedBankCard", // 聚合业务查询银行卡
    // 重置交易密码
    resetTradePwdSmsSend: "/api/restPwdSend", // 发送重置交易密码短信
    resetTradePwdSmsCheck: "/api/restPwdReceive", // 校验重置交易密码短信
    resetTradePwd: "/api/resettradepwd", // 重置交易密码
    changeTradePwd: "/api/modifyPwd", // 修改交易密码
    resetPwdRegister: "/api/resetPwdRegister", // 纯注册重置登录密码
    resetPwdSearch: "/api/resetPwdSearch", // 重置纯代销密码
    restPwdAuthSend: "/api/restPwdAuthSend", // 忘记密码发送
    restPwdAuthReceive: "/api/restPwdAuthReceive", // 忘记密码校验

    // 查询基金费率
    qryFundReadFile: "/api/qryFundReadFile", //  查询待签署文件列表
    fileReadRecord: "/api/fileReadRecord", // 签署文件/留痕
    codeReceivePay: "fundBuyOrderPayReceive", // 页面/短信/代扣支付接收
    collectFund: "/api/collectFund", // 关注
    unCollectFund: "/api/unCollectFund", // 取消关注
    acctChangetypeCheck: "/api/acctChangetypeCheck", // 判断是否符合转换成专业投资者条件
    baseOrdinary2Professional: "/api/investorsManageService", // 普通转专业
    baseProfessional2Ordinary: "/api/investorsManageService", // 专业转普通
    tradeDivideModify: "/api/tradeDivideModify", // 修改分红方式
    batchTradeDivideModify: "/api/batchTradeDivideModify", // 批量修改分红方式

    // 妥妥递，电子合同
    qryContractProduct: "/api/qryContractProduct", // 查询合同产品信息
    qryContractStatus: "/api/qryContractStatus", // 查询合同状态 -注册用户 创建订单 返回订单状态
    signContract: "/api/signContract", // 销售系统签署合同
    viewContract: "/api/viewContract", // 已签署合同查看
    qryContractOrderDetail: "/api/qryContractOrderDetail", // 查询合同订单详情
    precheckContractSign: "/api/preCheckContractSign", // 合同签署前校验
    checkQRCode: "/api/checkQRCode", // 获取二维码信息 校验二维码
    ttdDoubleRecordingConfig: "/api/ttdDoubleRecordingConfig", //	小程序自助双录配置话术配置
    ttdQryOrderVedioList: "/api/ttdQryOrderVedioList", // 获取小程序双录视频地址
    ttdQryUserNo: "/api/combThirdPartContractRegister", // 获取妥妥递账号
    combDoubleRecordBind: "/api/combDoubleRecordBind", // 双录结果绑定

    // 个人信息
    combQueryCustInfoByMinApp: "/api/combQueryCustInfoByMinApp", // 查询个人信息
    updAcctInfo: "/api/updAcctInfo", // 编辑个人信息
    combLoginPasswordUpdate: "/api/combLoginPasswordUpdate", // 修改登录密码
    updateLoginPwd: "/api/updateLoginPwd", // 修改登录密码
    acctRiskListManage: "/api/acctRiskListManage", // 检查客户风险
    combQueryProInvestInfo: "/api/combQueryProInvestInfo", // 查询专业投资者信息
    getAuthCode: "/api/getAuthCode", // 获取图形验证码
    sendSms: "/api/sendSms", // 发送短信验证码
    checkSmsCode: "/api/checkSmsCode", // 校验短信验证码
    modifyMobile: "/api/modifyMobile", // 增加/手机号修改
    unbindMobile: "/api/unbindMobile", // 解绑手机号
    bindMobile: "/api/bindMobile", // 绑定手机号
    modifyAcctExt: "/api/modifyAcctExt", // 更改头像
    combBankCardInfoUpdate: "/api/combBankCardInfoUpdate", // 修改银行卡信息
    combUpdateBankcardAuth: "/api/combUpdateBankcardAuth", // 激活银行卡
    combSignApply: "/api/combSignApply", // 发送页面签约
    combSignConfirm: "/api/combSignConfirm", // 校验页面签约
    combVerifyConfirm: "/api/combVerifyConfirm", // 校验页面鉴权
    combUnSignApply: "/api/combUnSignApply", // 支付方式解约申请
    combUnSignConfirm: "/api/combUnSignConfirm", // 支付方式解约验证
    qryBankCallbackInfo: "/api/qryBankCallbackInfo", // 页面鉴权银行返回报文
    qryCcbBankData: "/sale-mid-ump/bank/qryCcbBankData", // 页面鉴权建行网银直连渠道返回报文
    combQueryTargetFundLimit: "/api/combQueryTargetFundLimit", // 基金转换份额限制查询
    resetLoginPwdVerify: "/api/resetLoginPwdVerify", // 重置密码校验用户信息
    resetLoginPwd: "/api/resetLoginPwd", // 重置登录密码
    addPolicyLog: "/api/addPolicyLog", // 阅读协议留痕
    sendEmail: "/api/sendEmail", // 发送邮件验证码
    checkEmailCode: "/api/checkEmailCode", // 验证邮件验证码
    modifyEmail: "/api/modifyEmail", // 修改邮箱
    combTransRealtaBuy: "/api/combTransRealtaBuy",
    qryCustomizedServer: "/api/qryCustomizedServer", // 查询服务定制
    modifyCustomizedServer: "/api/modifyCustomizedServer", // 修改定制服务
    qryCrmStatements: "/api/qryCrmStatements", // 查询CRM对账单
    assetsPdf: "/sale-mid-ump/file/assetPdfDownload", // 下载资产证明pdf
    combQueryAppOnlineCardChange: "/api/combQueryAppOnlineCardChange", // 银行卡换卡记录查询
    combBankCardUpdate: "/api/combBankCardUpdate", // 银行卡变更
    appOnlineCardChange: "/api/appOnlineCardChange", // 银行卡换卡
    modifyMobileAuthApply: "/api/modifyMobileAuthApply", // 修改手机号鉴权申请
    modifyMobileAuthConfirm: "/api/modifyMobileAuthConfirm", // 修改手机号鉴权验证
    combBankCardUpdatePreCheck: "/api/combBankCardUpdatePreCheck", // 银行卡变更（预检）
    combBankCardPrepare: "/api/combBankCardPrepare", // 换卡前判断
    openAcctAfterUpd: "/api/openAcctAfterUpd", // 注册用户开户后更新缓存信息
    qryStrategyAsset: "/api/qryStrategyAsset", // 查询基金组合资产
    qryStrategyFundRatio: "/api/qryStrategyFundRatio", // 查询组合的基金占比情况
    qryStrategyAdjust: "/api/qryStrategyAdjust", // 查询组合调仓记录
    qryStrategyAdjustDetail: "/api/qryStrategyAdjustDetail", // 每期调仓的基金情况
    qryCombinationInfo: "/api/qryCombinationInfo", // 查询组合信息
    combInvestPlanManager: "/api/combInvestPlanManager", // 组合定投协议签署/修改/暂停/恢复/终止
    queryApproMatchRules: "/api/v1/queryApproMatchRules", // 查询基金风险匹配规则
    combUnSignBankHandler: "/api/combUnSignBankHandler", // 后台解约
    combPasswordCheck: "/api/combPasswordCheck", // 检验交易密码
    combQueryAppAcctList: "/api/combQueryAppAcctList", // 自助换卡记录查询
    payInform: "/api/payInform", // 页面支付结果查询
    qryBlackListService: "/api/qryBlackListService", // 反洗钱黑名单查询
    queryDesensitization: "/auth/desensitization", // 查询是否需要脱敏
    combQueryShortShareDetailTotal: "/api/combQueryShortShareDetailTotal", // 查询份额明细列表(到期日汇总)
    combQueryRealTransStatus: "/api/combQueryRealTransStatus", // 现金宝充值完成后查询交易状态
    acctBeforeLoginCheck: "/api/acctBeforeLoginCheck",
    bindCheck: "/api/bindCheck",
    bindMobileno: "/api/bindMobileno",
    verifyService: "/api/verifyService", // 判断用户某些新数据是否与原数据一样
    updRemark: "api/updRemark", // 更新预留信息
    qryAcctTracesLogList: "/api/qryAcctTracesLogList", // 留痕信息查询
    closeAccountMid: "/api/closeAccountMid", // 销户
    getFirstPlanDay: "/api/getFirstPlanDay", // 查询定投首次扣款日
    checkRiskInfo: "/api/checkRiskInfo",
    acctRiskinfoQuery: "/api/acctRiskinfoQuery",
    combRiskGardeQuery: "/api/combRiskGardeQuery",
    setQryallfund: "/api/setQryallfund", // 更新风险过滤标志

    // 投资者回访问卷
    qryReturnVisitStatus: "/api/qryReturnVisitStatus", // 查询投资者回访状态
    upReturnVisitStatus: "/api/upReturnVisitStatus" // 修改投资者回访状态
};
